import _defineProperty from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { DEBUG_BUILD } from '../debug-build.js';
import { defineIntegration } from '../integration.js';
import { debug } from '../utils/debug-logger.js';
import { isError, isPlainObject } from '../utils/is.js';
import { normalize } from '../utils/normalize.js';
import { addNonEnumerableProperty } from '../utils/object.js';
import { truncate } from '../utils/string.js';
var INTEGRATION_NAME = 'ExtraErrorData';

/**
 * Extract additional data for from original exceptions.
 */
var _extraErrorDataIntegration = function _extraErrorDataIntegration() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$depth = options.depth,
    depth = _options$depth === void 0 ? 3 : _options$depth,
    _options$captureError = options.captureErrorCause,
    captureErrorCause = _options$captureError === void 0 ? true : _options$captureError;
  return {
    name: INTEGRATION_NAME,
    processEvent: function processEvent(event, hint, client) {
      var _client$getOptions = client.getOptions(),
        _client$getOptions$ma = _client$getOptions.maxValueLength,
        maxValueLength = _client$getOptions$ma === void 0 ? 250 : _client$getOptions$ma;
      return _enhanceEventWithErrorData(event, hint, depth, captureErrorCause, maxValueLength);
    }
  };
};
var extraErrorDataIntegration = defineIntegration(_extraErrorDataIntegration);
function _enhanceEventWithErrorData(event) {
  var hint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var depth = arguments.length > 2 ? arguments[2] : undefined;
  var captureErrorCause = arguments.length > 3 ? arguments[3] : undefined;
  var maxValueLength = arguments.length > 4 ? arguments[4] : undefined;
  if (!hint.originalException || !isError(hint.originalException)) {
    return event;
  }
  var exceptionName = hint.originalException.name || hint.originalException.constructor.name;
  var errorData = _extractErrorData(hint.originalException, captureErrorCause, maxValueLength);
  if (errorData) {
    var contexts = _objectSpread({}, event.contexts);
    var normalizedErrorData = normalize(errorData, depth);
    if (isPlainObject(normalizedErrorData)) {
      // We mark the error data as "already normalized" here, because we don't want other normalization procedures to
      // potentially truncate the data we just already normalized, with a certain depth setting.
      addNonEnumerableProperty(normalizedErrorData, '__sentry_skip_normalization__', true);
      contexts[exceptionName] = normalizedErrorData;
    }
    return _objectSpread(_objectSpread({}, event), {}, {
      contexts: contexts
    });
  }
  return event;
}

/**
 * Extract extra information from the Error object
 */
function _extractErrorData(error, captureErrorCause, maxValueLength) {
  // We are trying to enhance already existing event, so no harm done if it won't succeed
  try {
    var nativeKeys = ['name', 'message', 'stack', 'line', 'column', 'fileName', 'lineNumber', 'columnNumber', 'toJSON'];
    var extraErrorInfo = {};

    // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
    for (var _i = 0, _Object$keys = Object.keys(error); _i < _Object$keys.length; _i++) {
      var key = _Object$keys[_i];
      if (nativeKeys.indexOf(key) !== -1) {
        continue;
      }
      var value = error[key];
      extraErrorInfo[key] = isError(value) || typeof value === 'string' ? truncate("".concat(value), maxValueLength) : value;
    }

    // Error.cause is a standard property that is non enumerable, we therefore need to access it separately.
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/cause
    if (captureErrorCause && error.cause !== undefined) {
      if (isError(error.cause)) {
        var errorName = error.cause.name || error.cause.constructor.name;
        extraErrorInfo.cause = _defineProperty({}, errorName, _extractErrorData(error.cause, false, maxValueLength));
      } else {
        extraErrorInfo.cause = error.cause;
      }
    }

    // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
    if (typeof error.toJSON === 'function') {
      var serializedError = error.toJSON();
      for (var _i2 = 0, _Object$keys2 = Object.keys(serializedError); _i2 < _Object$keys2.length; _i2++) {
        var _key = _Object$keys2[_i2];
        var _value = serializedError[_key];
        extraErrorInfo[_key] = isError(_value) ? _value.toString() : _value;
      }
    }
    return extraErrorInfo;
  } catch (oO) {
    DEBUG_BUILD && debug.error('Unable to extract extra data from the Error object:', oO);
  }
  return null;
}
export { extraErrorDataIntegration };